// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.stacked-bar-chart[data-v-0df472fe] {\n  overflow-x: auto;\n}\n", ""]);
// Exports
module.exports = exports;
